export default "__VITE_ASSET__DoowWegL__"